import * as React from "react";
import { AcceptInviteScreenStyle } from "./accept-invite-screen-style";
import { RootState } from "../../../../store/types";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { UserDataAndState, isUserData } from "common/Database";
import { getAppFacilities } from "webapp/lib/app-renderer";
import { memberJoinedOrg } from "../../../../routes";
import { trackEvent } from "../../../../analytics";
import { AcceptInviteBody } from "common/firebase-function-types";
import OrgsScreen from "../orgs-screen/orgs-screen";

interface RouteProps {
    readonly joinID: string | undefined;
    readonly orgName: string | undefined;
}

interface Props extends RouteComponentProps<RouteProps> {
    userData: UserDataAndState;
}

interface State {
    current: "start" | "accepting" | "success" | "fail";
    firstRun: boolean;
    message: string | undefined;
}

class AcceptInviteScreenImpl extends React.PureComponent<Props, State> {
    public state: State = {
        current: "start",
        firstRun: true,
        message: undefined,
    };

    public componentDidUpdate = async (_prevProps: Props) => {
        if (!isUserData(_prevProps.userData) && isUserData(this.props.userData)) {
            await this.acceptOrg();
            this.setState({ firstRun: false });
        }
    };

    private acceptOrg = async () => {
        const { userData, match } = this.props;
        if (!isUserData(userData) || match.params.joinID === undefined) return;

        this.setState({ current: "accepting" });

        const f = getAppFacilities();
        const body: AcceptInviteBody = { acceptCode: match.params.joinID };
        const result = await f.callAuthCloudFunction("acceptOrganizationInvite", body);
        if (result === undefined) {
            this.setState({ current: "fail" });
            return;
        }

        const json = await result.json();
        if (json.success === true) {
            this.setState({ current: "success" });
            this.props.history.push(memberJoinedOrg(json.orgID));
            trackEvent("org_member_invite_accept", { user_id: userData.id, org_id: json.orgID });
        } else {
            this.setState({ current: "fail", message: json.reason });
        }
    };

    public render(): React.ReactNode {
        return (
            <OrgsScreen loading={this.state.current === "accepting"}>
                {!this.state.firstRun && (
                    <AcceptInviteScreenStyle>
                        <div className="aiss-main-area">
                            <div>
                                You've been invited to join <span>{this.props.match.params.orgName ?? "a team"}</span>.
                            </div>
                            <button onClick={this.acceptOrg} disabled={this.state.current !== "start"}>
                                {this.state.current === "accepting" ? "Joining Team..." : "Join Team"}
                            </button>
                            {this.state.message !== undefined && <div className="aiss-error">{this.state.message}</div>}
                        </div>
                    </AcceptInviteScreenStyle>
                )}
            </OrgsScreen>
        );
    }
}

const mapState = (state: RootState) => ({
    userData: state.userData,
});

const AcceptInviteScreen = connect(mapState)(AcceptInviteScreenImpl);
export default AcceptInviteScreen;
